<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="back()"><ion-icon name="arrow-back-outline"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title>Bind</ion-title>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment value="{{segment}}" (ionChange)="segmentChanged()">
      <ion-segment-button value="0">
        <ion-label>Group of devices</ion-label>
      </ion-segment-button>
      <ion-segment-button value="1">
        <ion-label>Bind device</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" padding>
  <swiper-container [pager]="false" [simulateTouch]="false" [allowTouchMove]="false" #slides [touchStart]="touchStart()" [speed]="SPEED">
    <swiper-slide>
      <app-group-bind></app-group-bind>
    </swiper-slide>

    <swiper-slide>
      <app-device-bind></app-device-bind>
    </swiper-slide>
  </swiper-container>
</ion-content>
